module.exports = __webpack_public_path__ + "img/graphy-1.bb179117.png";